const DURATION = 600;
const FORWARD_NAV_KEY = 'vt-forward';
const DEFAULT_TRANSITION_ICON = 'https://cdn.prod.website-files.com/69e0f50e679975e51d373132/6a022ffa2a010916ef987945_logo-mark.svg';
const TRANSITION_IMAGE_ATTR = 'data-vt-image';
const TRANSITION_STYLE_ATTR = 'data-vt-style';

const imageMap = {
  '/': DEFAULT_TRANSITION_ICON,
};

const styleMap = {};

const hasViewTransitionAttribute = (link) =>
  Array.from(link.attributes).some((attr) => attr.name.startsWith('data-vt-'));

const getLinkUrl = (link) => {
  try {
    return new URL(link.getAttribute('href'), window.location.origin);
  } catch (error) {
    return null;
  }
};

const getNormalizedPath = (url) => url.pathname.replace(/\/$/, '') || '/';

const isEligibleInternalLink = (link) => {
  const url = getLinkUrl(link);

  if (!url) {
    return false;
  }

  if (url.hostname !== window.location.hostname) {
    return false;
  }

  if (link.getAttribute('href') === '#') {
    return false;
  }

  if (url.pathname === window.location.pathname && url.hash) {
    return false;
  }

  if (link.hasAttribute('data-vt-ignore') || link.target === '_blank') {
    return false;
  }

  return true;
};

const applyInlineStyles = (element, styles) => {
  if (!styles) {
    return;
  }

  styles.split(';').forEach((pair) => {
    const separatorIndex = pair.indexOf(':');

    if (separatorIndex === -1) {
      return;
    }

    element.style.setProperty(
      pair.slice(0, separatorIndex).trim(),
      pair.slice(separatorIndex + 1).trim(),
    );
  });
};

const mapTransitionAttributes = () => {
  document.querySelectorAll('a[href]').forEach((link) => {
    if (!isEligibleInternalLink(link) || hasViewTransitionAttribute(link)) {
      return;
    }

    const url = getLinkUrl(link);
    const path = getNormalizedPath(url);

    link.setAttribute(TRANSITION_IMAGE_ATTR, imageMap[path] || DEFAULT_TRANSITION_ICON);

    if (styleMap[path]) {
      link.setAttribute(TRANSITION_STYLE_ATTR, styleMap[path]);
    }
  });
};

export const initViewTransitionOverlay = () => {
  const overlay = document.createElement('div');
  overlay.className = 'vt-overlay';

  const image = document.createElement('img');
  image.className = 'vt-overlay__image';
  image.alt = '';
  overlay.appendChild(image);

  document.body.appendChild(overlay);

  const isForwardNav = window.sessionStorage.getItem(FORWARD_NAV_KEY);
  window.sessionStorage.removeItem(FORWARD_NAV_KEY);

  if (!isForwardNav) {
    const kill = document.createElement('style');
    kill.textContent = '::view-transition-old(root), ::view-transition-new(root) { animation: none !important; }';
    document.head.appendChild(kill);
  }

  window.addEventListener('pageshow', (event) => {
    if (!event.persisted) {
      return;
    }

    overlay.removeAttribute('style');
    overlay.style.animation = 'none';
    overlay.style.transform = 'scaleY(0)';
    overlay.classList.remove('is-active');
    image.src = '';
  });

  mapTransitionAttributes();

  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href]');

    if (!link || !isEligibleInternalLink(link)) {
      return;
    }

    if (event.metaKey || event.ctrlKey || event.shiftKey) {
      return;
    }

    event.preventDefault();

    image.src = link.getAttribute(TRANSITION_IMAGE_ATTR) || DEFAULT_TRANSITION_ICON;
    overlay.removeAttribute('style');
    applyInlineStyles(overlay, link.getAttribute(TRANSITION_STYLE_ATTR));
    overlay.classList.add('is-active');

    window.sessionStorage.setItem(FORWARD_NAV_KEY, '1');

    window.setTimeout(() => {
      window.location.href = link.href;
    }, DURATION);
  });
};
